import React, { useEffect, useState } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import axios from "axios";
import PageTitle from "../components/pageTitle.js";

const AdminInquiryList = () => {
  const baseUrl = process.env.REACT_APP_API_BASE_URL;
  // const isAdmin = true; // TODO: 나중엔 sessionStorage로 교체
  const isAdmin = sessionStorage.getItem("isAdmin") === "true";
  const navigate = useNavigate();
  const [inquiries, setInquiries] = useState([]);
  const [selectedIds, setSelectedIds] = useState([]);
  const [search, setSearch] = useState("");
  const [searchField, setSearchField] = useState("name");
  const [searchKeyword, setSearchKeyword] = useState("");

  useEffect(() => {
    if (isAdmin) {
      axios
        .get(`${baseUrl}/api/inquiry/list`)
        .then((res) => {
          setInquiries(res.data);
          // console.log(res.data);
        })
        .catch((err) => console.error("❌ 문의 목록 불러오기 실패:", err));
    }
  }, [isAdmin]);

  if (!isAdmin) return <Navigate to="/" />;

  const toggleSelect = (id) => {
    setSelectedIds((prev) =>
      prev.includes(id) ? prev.filter((item) => item !== id) : [...prev, id]
    );
  };

  const handleSearch = () => {
    axios
      .get(`${baseUrl}/api/inquiry/search`, {
        params: {
          field: searchField,
          keyword: searchKeyword,
        },
      })
      .then((res) => setInquiries(res.data))
      .catch((err) => console.error("검색 실패", err));
  };

  const handleDeleteSelected = () => {
    if (selectedIds.length === 0) {
      alert("삭제할 항목을 선택해주세요.");
      return;
    }
    if (!window.confirm("정말 삭제하시겠습니까?")) return;

    axios
      .delete(`${baseUrl}/api/inquiry`, { data: selectedIds })
      .then(() => {
        alert("삭제되었습니다.");
        setInquiries((prev) => prev.filter((i) => !selectedIds.includes(i.id)));
        setSelectedIds([]);
      })
      .catch(() => alert("삭제 실패"));
  };

  return (
    <div className="w-full px-4 py-16">
      <div className="max-w-[1000px] mx-auto">
        <div>
          <PageTitle title="문의/신청 내역" />
        </div>

        <table className="w-full text-sm border border-gray-200 rounded overflow-hidden">
          <thead className="bg-gray-100 text-gray-600">
            <tr className="border-b">
              <th className="p-2 text-center">
                <input
                  type="checkbox"
                  onChange={(e) => {
                    setSelectedIds(
                      e.target.checked ? inquiries.map((i) => i.id) : []
                    );
                  }}
                  checked={
                    inquiries.length > 0 &&
                    selectedIds.length === inquiries.length
                  }
                />
              </th>
              <th className="p-2 text-center">번호</th>
              <th className="p-2 text-left">연락처</th>
              <th className="p-2 text-left">이메일</th>
              <th className="p-2 text-left">글제목</th>
              <th className="p-2 text-center">글쓴이</th>
              <th className="p-2 text-center">작성일</th>
            </tr>
          </thead>
          <tbody>
            {inquiries.map((item, idx) => (
              <tr
                key={item.id}
                className="border-b hover:bg-gray-50 cursor-pointer"
                onClick={() => navigate(`/admin/inquiries/${item.id}`)}>
                <td className="p-2 text-center">
                  <input
                    type="checkbox"
                    onClick={(e) => e.stopPropagation()}
                    onChange={() => toggleSelect(item.id)}
                    checked={selectedIds.includes(item.id)}
                  />
                </td>
                <td className="p-2 text-center">{idx + 1}</td>
                <td className="p-2">{item.phoneNumber}</td>
                <td className="p-2 text-center">{item.email}</td>
                <td className="p-2">
                  {item.title || item.content?.slice(0, 20)}
                </td>
                <td className="p-2 text-center">{item.name}</td>
                <td className="p-2 text-center">
                  {item.createdAt?.slice(0, 10)}
                </td>
              </tr>
            ))}
          </tbody>
        </table>

        <div className="flex justify-between items-center mt-6">
          <button
            onClick={handleDeleteSelected}
            className="border px-4 py-2 text-sm">
            선택삭제
          </button>

          <div className="flex items-center gap-2">
            <button className="border px-2 py-1">&lt;</button>
            <span className="border px-3 py-1 bg-black text-white">1</span>
            <button className="border px-2 py-1">&gt;</button>
          </div>

          <div className="flex items-center gap-2">
            <select
              value={searchField}
              onChange={(e) => setSearchField(e.target.value)}
              className="border px-2 py-1 text-sm">
              <option value="name">이름</option>
              <option value="phoneNumber">이메일</option>
              <option value="phoneNumber">연락처</option>
              <option value="content">내용</option>
            </select>

            <input
              type="text"
              value={searchKeyword}
              onChange={(e) => setSearchKeyword(e.target.value)}
              onKeyDown={(e) => e.key === "Enter" && handleSearch()}
              placeholder="검색어를 입력하세요"
              className="border px-3 py-1 text-sm"
            />
            <button className="border px-4 py-1 text-sm" onClick={handleSearch}>
              검색
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdminInquiryList;
